import React from 'react';
import { authRoles } from '../../store/auth';

const MyContentConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: true,
        },
        footer: {
          display: true,
        },
      },
    },
  },
  auth: authRoles.user,
  routes: [
    {
      path: '/settings',
      component: React.lazy(() => import('./Settings')),
    },
  ],
};

export default MyContentConfig;
